// import { useState, useEffect } from "react";

const RPointField = ({ value, miniature = false, width, height }) => {
  // const mapStyle = {
  //   width: width ? width : miniature ? "230px" : "450px",
  //   height: height ? height : miniature ? "160px" : "300px",
  // };

  // const [point, setPoint] = useState(null);
  // const [image, setImage] = useState(null);

  // useEffect(() => {
  //   if (!value) return;

  //   const { point, image } = value;

  //   if (point) setPoint(Object.values(point));
  //   if (image) setImage(image);
  // }, [value]);

  return <div style={miniature ? { pointerEvents: "none" } : {}}></div>;
};

export default RPointField;
